interface LogoProps {
  variant?: "default" | "white";
  className?: string;
  showText?: boolean;
}

export function Logo({
  variant = "default",
  className = "h-8",
  showText = false,
}: LogoProps) {
  const src = variant === "white" ? "/logo-white.svg" : "/logo.svg";

  return (
    <div className="flex items-center gap-2">
      <img src={src} alt="ARCUS Learning" className={className} />
      {showText && (
        <span className="font-semibold text-xl tracking-tight">
          ARCUS Learning
        </span>
      )}
    </div>
  );
}
